import { render } from "./Invoice.vue?vue&type=template&id=78d7f859"
import script from "./Invoice.vue?vue&type=script&lang=ts"
export * from "./Invoice.vue?vue&type=script&lang=ts"
script.render = render

export default script